import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "../store/store";
import UserLogin from "../views/UserLogin.vue";
import CharacterSelect from "../views/CharacterSelect.vue";
import { getToken } from "@/common/authentication/auth";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Select",
    component: CharacterSelect,
    meta: {
      allowAnon: true,
    },
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutGame.vue"),
    meta: {
      allowAnon: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: UserLogin,
    meta: {
      allowAnon: true,
    },
  },
  {
    path: "/character/:character_id",
    name: "Character",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CharacterPage.vue"),
  },
  {
    path: "/ForgotPassword",
    name: "ForgotPassword",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //C:\Users\arshp\Documents\GitHub\Crescent\src\components\ForgotPassword.vue
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/ForgotPassword.vue"
      ),
    meta: {
      allowAnon: true,
    },
  },
  {
    path: "/PasswordChange/:user_id",
    name: "PasswordChange",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //C:\Users\arshp\Documents\GitHub\Crescent\src\components\ForgotPassword.vue
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PasswordChange.vue"),
    meta: {
      allowAnon: true,
    },
  },
  {
    path: "/Adventure/:adventure_id",
    name: "Adventure",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/UserAdventure.vue"),
  },
  {
    path: "/Adventure/:adventure_id/:character_id",
    name: "EditAdventureCharacter",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/EditAdventureCharacter.vue"
      ),
  },
  {
    path: "/AddNewAdventure",
    name: "AddNewAdventure",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AddNewAdventure.vue"),
  },
  // {
  //   path: "/Journal/:adventure_id/",
  //   name: "Journal",

  //   component: () =>
  //     import(
  //       /* webpackChunkName: "about" */ "../components/adventure/Journal/AdventureJournal.vue"
  //     ),
  // },
  // {
  //   path: "/Manual/:adventure_id",
  //   name: "Manual",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "about" */ "../components/adventure/Manual/CrescentManual.vue"
  //     ),
  // },
  // {
  //   path: "/NpcAlmanac/:adventure_id",
  //   name: "NpcAlmanac",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "about" */ "../components/adventure/NpcAlmanac/NpcAlmanac.vue"
  //     ),
  // },
  // {
  //   path: "/MonsterMaker/:adventure_id",
  //   name: "MonsterMaker",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "about" */ "../components/adventure/MonsterMaker/MonsterMaker.vue"
  //     ),
  // },
  // {
  //   path: "/AddNewMonster/:adventure_id",
  //   name: "CreateMonster",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visite.
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "CreateMonster" */ "../components/adventure/MonsterMaker/CreateMonster.vue"
  //     ),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let token = store.getters.authToken;
  // If we couldn't get the token, try to get it locally
  if (!token) {
    token = getToken();
  }
  if (to.path !== "/login" && !token) {
    next("/login");
  }
  next();
});

export default router;
